import { useTracking } from 'react-tracking';
import { format } from 'date-fns';
import { Row, Column } from '@simplywallst/ui-core';
import {
  Avatar,
  StyledLink,
  MetadataSection,
  PublishedDate,
  CommentsLink,
} from './styled';
import ReviewedByList from './ReviewedByList';
import type { Author } from '../hooks/useArticle/types';

interface Props {
  name: string;
  slug: string;
  photoURL: string;
  publishDate: string;
  updatedDate: string;
  viewCommentsText: string;
  reviewedBy?: Author[];
  onCommentsClick: (e) => void;
}
const Metadata = ({
  name,
  slug,
  photoURL,
  publishDate,
  updatedDate,
  viewCommentsText,
  reviewedBy,
  onCommentsClick,
}: Props) => {
  const { trackEvent } = useTracking();
  const publishDateFormatted = format(new Date(publishDate), 'MMMM dd, yyyy');
  const updatedDateFormatted =
    updatedDate !== publishDate
      ? format(new Date(updatedDate), 'MMMM dd, yyyy')
      : undefined;
  return (
    <>
      <MetadataSection>
        <Row>
          <Avatar src={photoURL} alt={name} />
          <Column fillVoid alignSelf={reviewedBy?.length ? 'auto' : 'center'}>
            <StyledLink
              href={`https://simplywall.st/news/about-simply-wall-st-news/${slug}`}
              target="_blank"
              onClick={() => {
                trackEvent({
                  type: 'track',
                  subject: 'author_metadata',
                  action: 'click',
                  slug: slug,
                });
              }}
            >
              {name}
            </StyledLink>
            <ReviewedByList authors={reviewedBy} />
          </Column>
        </Row>
        <CommentsLink href="#comments" onClick={onCommentsClick}>
          {viewCommentsText}
        </CommentsLink>
      </MetadataSection>
      <Row>
        <PublishedDate>
          {updatedDate ? '' : 'Published'}{' '}
          <time dateTime={publishDate}>{publishDateFormatted}</time>
        </PublishedDate>
        {updatedDate && (
          <PublishedDate>
            &nbsp;&nbsp;•&nbsp;&nbsp;Updated{' '}
            <time dateTime={updatedDate}>{updatedDateFormatted}</time>
          </PublishedDate>
        )}
      </Row>
    </>
  );
};

export default Metadata;
